import styled, { css } from 'styled-components';

const OrderStatusBadgeDot = styled.div`
  border-radius: var(--size-border-radius-circle);
  height: 8px;
  margin-right: 4px;
  width: 8px;
`;

const OrderStatusBadge = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border: 1px solid;
  border-radius: var(--size-border-radius-circle);
  color: var(--color-fg-default);
  display: flex;
  height: 24px;
  line-height: 24px;
  min-width: 60px;
  padding: 0px 8px;
  white-space: nowrap;
  width: fit-content;

  ${({ color }) => css`
    border-color: ${color};

    ${OrderStatusBadgeDot} {
      background-color: ${color};
    }
  `}
`;

export { OrderStatusBadge, OrderStatusBadgeDot };
